/* START_MODULE_CONTRACT
 * PURPOSE: Frontend model: ProjectRole.
 * SCOPE: DTO mapping / constants.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API
 * ROLE: TYPES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * ProjectRole - Frontend model: ProjectRole.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: class-контракт, METHOD-обёртки логики, END_CLASS.
 * END_CHANGE_SUMMARY
 */

/* START_CLASS_ProjectRole */
/* START_CONTRACT: ProjectRole
 * PURPOSE: Клиентская модель роли проекта с разрешением совмещаемых ролей.
 * INPUTS: { id, projectId, name, shortName, sortOrder, workloadPercent, concurrentRoleIds, createdAt }.
 * OUTPUTS: экземпляр ProjectRole; getConcurrentRoleLabels().
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-API, M-PROJECT-ROLE
 * END_CONTRACT: ProjectRole
 */
export default class ProjectRole {
  constructor({
    id,
    projectId,
    name,
    shortName,
    sortOrder,
    workloadPercent,
    concurrentRoleIds,
    createdAt,
  }) {
    this.id = id;
    this.projectId = projectId;
    this.name = name ?? '';
    this.shortName = shortName ?? '';
    this.sortOrder = sortOrder ?? 0;
    this.workloadPercent = workloadPercent ?? 100;
    this.concurrentRoleIds = concurrentRoleIds ?? [];
    this.createdAt = createdAt ? new Date(createdAt) : null;
  }

  /* START_METHOD_getConcurrentRoleLabels */
  /* START_CONTRACT: getConcurrentRoleLabels
   * PURPOSE: Вернуть короткие подписи совмещаемых ролей по их id.
   * INPUTS: { allRoles: ProjectRole[] - полный список ролей проекта }.
   * OUTPUTS: { string[] - подписи (shortName или name) существующих совмещаемых ролей }.
   * SIDE_EFFECTS: нет.
   * LINKS: M-PROJECT-ROLE
   * END_CONTRACT: getConcurrentRoleLabels
   */
  getConcurrentRoleLabels(allRoles) {
    if (!this.concurrentRoleIds.length || !allRoles?.length) {
      return [];
    }
    const roleMap = new Map(allRoles.map((role) => [role.id, role]));
    return this.concurrentRoleIds
      .map((id) => roleMap.get(id))
      .filter(Boolean)
      .map((role) => role.shortName || role.name);
  }
  /* END_METHOD_getConcurrentRoleLabels */

  static fromResponse(data) {
    return new ProjectRole(data);
  }
}
/* END_CLASS_ProjectRole */
